import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOFeatureGrid from './components/SEOFeatureGrid';
import ContentHub from './components/ContentHub';
import Reviews from './components/Reviews';
import PanoramicCTA from './components/PanoramicCTA';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9935mnk7gok24d4a94g';

const siteUrl = import.meta.env.VITE_SITE_URL;

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'SpreadsheetHub',
  url: siteUrl,
  description: 'Discover the best Hipobuy Spreadsheet resources, product lists, QC guides, and category rankings. Independent spreadsheet research platform for smarter shopping.',
  image: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Hipobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Hipobuy Spreadsheet is a structured product research resource that helps shoppers discover products through organized lists, category collections, and comparison guides across 14 curated categories.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is SpreadsheetHub affiliated with any shopping agent?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No. SpreadsheetHub is an independent research platform. We are not affiliated with Hipobuy, Kakobuy, CSSBuy, Superbuy, or Oopbuy.',
      },
    },
    {
      '@type': 'Question',
      name: 'How many product categories are available?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'SpreadsheetHub covers 14 product categories including Shoes, Hoodies, T-Shirts, Jackets, Pants, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff.',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SEOFeatureGrid />
        <ContentHub />
        <Reviews />
        <PanoramicCTA />
      </main>
      <Footer formSubmitAddr={FORM_SUBMIT_ADDR} />
    </>
  );
}